import {Flex, FlexProps} from '@chakra-ui/react';
import {GeoIconNav} from 'components/icons/GeoIconNav';
import {GeoLogoNav} from 'components/icons/GeoLogoNav';
import LanguageSelector from 'components/LanguageSelector';
import {useLanguageHook} from 'modules/i18n/hooks';
import {useLocalizedNavigation} from 'modules/navigation/hooks';
import React from 'react';

export interface GeoDesktopNavProps extends FlexProps {
	listLink?: any[];
}

export const GeoDesktopNav: React.FC<GeoDesktopNavProps> = ({
	listLink
}: GeoDesktopNavProps) => {
	const [extended] = React.useState(false);
	const {push} = useLocalizedNavigation();
	const {changePreferredlanguage} = useLanguageHook();

	const onChangeLanguage = (language: string) => {
		// only if logged in
		if (changePreferredlanguage) {
			changePreferredlanguage.execute(language);
		}
	};

	return (
		<Flex
			position='fixed'
			top='0'
			left='0'
			height='100vh'
			pl={'0.5em'}
			pt={5}
			gap={3}
			flexDirection={'column'}
			alignItems='flex-start'
			zIndex={11111}
			pr={'1em'}
		>
			<GeoLogoNav
				src='logo_menu'
				variant='link'
				extended={extended}
				onClick={() => push('home')}
			/>
			{listLink.map(({src, link, label}) => {
				return (
					<GeoIconNav
						key={src}
						src={src}
						link={link}
						label={label}
						extended={extended}
					/>
				);
			})}
			{/* 
			<GeoLogoNav
				src={extended ? 'reverseArrow' : 'arrow'}
				extended={extended}
				variant='link'
				onClick={() => setExtended(!extended)}
			/> */}
			<LanguageSelector onChange={onChangeLanguage} />
		</Flex>
	);
};
